import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            "AIzaSyDkngxEwYBG1f3bmbgERaLAVGvA4ee35zs",
  authDomain:        "ericgcuts-14808.firebaseapp.com",
  projectId:         "ericgcuts-14808",
  storageBucket:     "ericgcuts-14808.firebasestorage.app",
  messagingSenderId: "282239244122",
  appId:             "1:282239244122:web:835c4e85ce50a69a808563",
};

const app = initializeApp(firebaseConfig);
export const db   = getFirestore(app);
export const auth = getAuth(app);
